<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
/>
<main class="tw-w-full">
   <!--  <div class="tw-hidden md:tw-block tw-px-[5vw] md:tw-px-[4vw] tw-mt-3">
        <ngx-slick-carousel
            class="carousel"
            #slickModal="slick-carousel"
            [config]="slideConfig"
            (afterChange)="afterChange($event)"
            (beforeChange)="beforeChange($event)"
        >
            <div ngxSlickItem *ngFor="let list of bannerData" class="tw-mb-3">
                <div
                    class="tw-relative tw-w-full md:tw-min-h-[490px] md:tw-h-[33vh] lg:tw-h-[33vh] xl:tw-h-[81vh] tw-overflow-hidden tw-rounded-lg md:tw-rounded-2xl"
                >
                    <img
                        [attr.ga-event-id]="
                            list?.campaigndetails?.campaignName +
                            '_main_banner_button_promotion_click'
                        "
                        ga-event-category="Promotion Button"
                        [attr.ga-event-label]="
                            list?.campaigndetails?.campaignName +
                            ' Main Banner Main Button Click'
                        "
                        ga-track="track"
                        [src]="list?.campaigndetails?.bannerImageUrl"
                        alt="slides"
                        class="tw-w-full tw-h-full tw-cursor-pointer"
                        (click)="viewCampaignDetails(list)"
                    />
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
    <div class="tw-block md:tw-hidden tw-px-[5vw] md:tw-px-[4vw] tw-mt-[4rem]">
        <ngx-slick-carousel
            class="carousel"
            #slickModal="slick-carousel"
            [config]="slideConfig"
            (afterChange)="afterChange($event)"
            (beforeChange)="beforeChange($event)"
        >
            <div
                ngxSlickItem
                *ngFor="let slide of bannerData"
                class="md:tw-mb-16"
            >
                <div
                    class="tw-min-h-[500px] tw-h-auto sm:tw-h-[70vh] tw-rounded-2xl tw-overflow-hidden"
                    [ngClass]="
                        slide.id == 1
                            ? 'tw-cursor-pointer'
                            : 'tw-cursor-default'
                    "
                >
                    <img
                        [attr.ga-event-id]="
                            slide?.campaigndetails?.campaignName +
                            '_main_banner_button_promotion_click'
                        "
                        ga-event-category="Promotion Button"
                        [attr.ga-event-label]="
                            slide?.campaigndetails?.campaignName +
                            ' Main Banner Main Button Click'
                        "
                        ga-track="track"
                        class="tw-cursor-pointer tw-min-h-[500px] tw-w-full"
                        [src]="
                            slide?.campaigndetails?.bannerMobileImageUrl
                                ? slide?.campaigndetails?.bannerMobileImageUrl
                                : slide?.campaigndetails?.bannerImageUrl
                        "
                        (click)="onClickImageRoute(slide.campaignUrl)"
                        alt="Mobile Banner Slide"
                    />
                </div>
            </div>
        </ngx-slick-carousel>
    </div> -->

    <app-whats-new-banner [bannerData]="bannerData"></app-whats-new-banner>
    <!-- What's New Intro -->
    <div
        id="desktopCampaign"
        class="tw-gap-[10px] tw-flex tw-flex-col tw-items-start tw-px-[8vw] md:tw-px-[5vw] tw-pt-[30px] tw-mt-10 md:tw-mt-6"
    >
        <div class="tw-text-left">
            <p
                class="tw-w-full tw-text-[22px] md:tw-text-[28px] tw-text-[#0F3172] tw-font-bold tw-leading-[140%]"
            >
                {{ whatsNewTitle }}
            </p>
            <p
                class="tw-text-[14px] tw-text-[#1A202C] tw-font-normal tw-leading-[22px]"
                [innerHTML]="whatsNewDesc"
            ></p>
        </div>
    </div>
    <app-campaigns-section
        *ngIf="campaignData.length > 0"
        [campaignData]="campaignData"
        [partnershipData]="partnershipData"
        (campDetails)="viewCampaignDetails($event)"
        (openDialog)="openDialog($event)"
    ></app-campaigns-section>

    <app-news-section
        *ngIf="newsData.length > 0"
        [newsData]="newsData"
        (newsDetails)="viewCampaignDetails($event)"
    ></app-news-section>

    <app-insights-section
        *ngIf="insightsData.length > 0"
        [insightsData]="insightsData"
        (insightsDetails)="viewCampaignDetails($event)"
    ></app-insights-section>
</main>
<app-footer [selectedLanguage]="selectedLanguage" />
